import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AUDIT_CAMPAIGN_INITIATE, BULK_PAY_APPROVALS, BULK_PAY_HISTORY, BULK_PAY_INITIATE, CREATE_SUBSCRIPTION, LIST_ACCESS_FEE_PLANS, LIST_BILLING_PLAN_REQUESTS, LIST_SUBSCRIPTION_REQUESTS, CREATE_SHIFT, CREATE_SLAB, CREATE_GEO_SLAB, LIST_SUBSCRIPTIONS, BULK_CREATE_SUBSCRIPTION, LIST_REDEEMS, CREATE_REDEEM, INCENTIVE_APPROVAL_REQUESTS, CREATE_LIMIT_STORE, LIST_LIMIT_STORE, LIST_LIMIT_APPROVALS, SLAB_APPROVAL_REQUESTS } from 'src/app/routes';
import { AUTHZ_FEATURES } from 'src/app/constants/permissions';
import { permissionSlugs } from 'src/app/utils/permission.utils';
import { SharedService } from '../shared.service';
import { AuthService } from 'src/app/auth.service';

type MenuOption = {
  name: string;
  path: string;
  permission?: string | string[];
  feature?: string;
  permissionActions?: string[];
  allowWhenPanelOff?: boolean;
};
type MenuItem = {
  name: string,
  icon: string,
  expanded?: boolean,
  options: MenuOption[];
};

const MENU_ITEMS: MenuItem[] = [
  {
    name: 'Slab',
    icon: 'directions_bike',
    options: [
      {
        name: 'View Slabs',
        path: '/slabs',
        permissionActions: ['view'],
        feature: AUTHZ_FEATURES.SLAB
      },
      {
        name: 'Slab Approval Requests',
        path: `/${SLAB_APPROVAL_REQUESTS}`,
        permissionActions: ['create', 'view', 'approve'],
        feature: AUTHZ_FEATURES.SLAB
      },
      {
        name: 'Create Shift',
        path: CREATE_SHIFT,
        permissionActions: ['create'],
        feature: AUTHZ_FEATURES.SLAB
      },
      {
        name: 'Create Slab',
        path: CREATE_SLAB,
        permissionActions: ['create'],
        feature: AUTHZ_FEATURES.SLAB
      },
      {
        name: 'Create Geo Slab',
        path: CREATE_GEO_SLAB,
        permissionActions: ['createGeoSlab'],
        feature: AUTHZ_FEATURES.SLAB
      }
    ]
  },
  {
    name: 'Incentive',
    icon: 'face',
    options: [
      {
        name: 'View Incentives',
        path: '/incentives',
        permissionActions: ['view', 'edit', 'approve'],
        feature: AUTHZ_FEATURES.INCENTIVE,
      },
      {
        name: 'Incentive Approval Requests',
        path: `/${INCENTIVE_APPROVAL_REQUESTS}`,
        permissionActions: ['view', 'edit', 'approve'],
        feature: AUTHZ_FEATURES.INCENTIVE,
      },
      {
        name: 'Create Incentive',
        path: '/createIncentive',
        permissionActions: ['edit'],
        feature: AUTHZ_FEATURES.INCENTIVE,
      },
      {
        name: 'iAllocator',
        path: '/newIncentive',
        permissionActions: ['edit'],
        feature: AUTHZ_FEATURES.INCENTIVE,
      },
      {
        name: 'iAllocator constructs upload',
        path: '/uploadConstruct',
        permission: 'iallocator_construct_upload'
      }
    ]
  },
  {
    name: 'Penalty & Reward Campaign',
    icon: 'campaign',
    options: [
      {
        name: 'View Campaigns',
        path: '/campaigns',
        permission: 'view_penalty_reward'
      },
      {
        name: 'Create Campaign',
        path: '/penalty-reward-campaign/create',
        permission: 'edit_penalty_reward'
      },
      {
        name: 'Audit Campaign',
        path: AUDIT_CAMPAIGN_INITIATE,
        permission: 'edit_audit_campaign'
      }
    ]
  },
  {
    name: 'Bulk Payment',
    icon: 'payment',
    options: [
      {
        name: 'New payment',
        path: BULK_PAY_INITIATE,
        permissionActions: ['create'],
        feature: AUTHZ_FEATURES.BULK_PAY,
      },
      {
        name: 'Approvals',
        path: BULK_PAY_APPROVALS,
        permissionActions: ['view', 'create', 'approve'],
        feature: AUTHZ_FEATURES.BULK_PAY,
      },
      {
        name: 'History',
        path: BULK_PAY_HISTORY,
        permissionActions: ['view'],
        feature: AUTHZ_FEATURES.BULK_PAY,
      }
    ]
  },
  {
    name: 'Subscriptions',
    icon: 'card_membership',
    options: [
      {
        name: 'Create Rule',
        path: CREATE_SUBSCRIPTION,
        permissionActions: ['create'],
        feature: AUTHZ_FEATURES.SUBSCRIPTION,
      },
      {
        name: 'List Rules',
        path: LIST_SUBSCRIPTIONS,
        permissionActions: ['view'],
        feature: AUTHZ_FEATURES.SUBSCRIPTION,
      },
      {
        name: 'List AccessFee Plan',
        path: LIST_ACCESS_FEE_PLANS,
        permissionActions: ['view'],
        feature: AUTHZ_FEATURES.BILLING_PLANS,
      },
      {
        name: 'Subscription Requests',
        path: LIST_SUBSCRIPTION_REQUESTS,
        feature: AUTHZ_FEATURES.SUBSCRIPTION,
      },
      {
        name: 'Access Fee Requests',
        path: LIST_BILLING_PLAN_REQUESTS,
        feature: AUTHZ_FEATURES.BILLING_PLANS,
      },
      {
        name: 'Bulk Create Subscription',
        path: BULK_CREATE_SUBSCRIPTION,
        permissionActions: ['create'],
        feature: AUTHZ_FEATURES.SUBSCRIPTION,
      }
    ]
  },
  {
    name: 'Redeem',
    icon: 'redeem',
    options: [
      {
        name: 'List Rules',
        path: LIST_REDEEMS,
        permission: 'redeem_list'
      },
      {
        name: 'Create Rule',
        path: CREATE_REDEEM,
        permission: 'redeem_add'
      }
    ]
  },
  {
    name: 'Limit Store',
    icon: 'store',
    options: [
      {
        name: 'List Limits',
        path: LIST_LIMIT_STORE,
        permissionActions: ['view', 'edit', 'approve'],
        feature: AUTHZ_FEATURES.LIMIT_STORE,
      },
      {
        name: 'Approvals',
        path: LIST_LIMIT_APPROVALS,
        permissionActions: ['view', 'edit', 'approve', 'approvalView'],
        feature: AUTHZ_FEATURES.LIMIT_STORE,
      },
      {
        name: 'Create Limit',
        path: CREATE_LIMIT_STORE,
        permissionActions: ['edit'],
        feature: AUTHZ_FEATURES.LIMIT_STORE,
      }
    ]
  }
];

@Component({
  selector: 'app-sidenav-list',
  templateUrl: './sidenav-list.component.html',
  styleUrls: ['./sidenav-list.component.css']
})
export class SidenavListComponent implements OnChanges, OnInit {
  @Input('toggleList') isExpanded: boolean;
  @Input('access') accessRights: string[] = [];
  @Output() expand = new EventEmitter<boolean>();

  menuItems: MenuItem[] = [];

  // Hides the entire Redeem section until infra enables the redeem ingress.
  private isRedeemRuleEnabled = false;

  constructor(
    public _route: Router,
    private sharedService: SharedService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.sharedService.fetchDashboardConfig().subscribe(
      (res: any) => {
        this.isRedeemRuleEnabled = !!(res && res.data && res.data.isRedeemRuleEnabled);
        this.filterMenuItems();
      },
      () => { this.isRedeemRuleEnabled = false; }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.accessRights) {
      this.filterMenuItems();
    }
  }

  filterMenuItems() {
    const authzPanels = this.authService.getAuthzPanels();
    this.menuItems = MENU_ITEMS
      .map(item => {
        const options = item.options
          .filter(option => {
            // Drop every redeem option when disabled so the whole Redeem section disappears
            // (the trailing options.length filter removes the now-empty menu item).
            const isRedeemOption = option.path === LIST_REDEEMS || option.path === CREATE_REDEEM;
            if (isRedeemOption && !this.isRedeemRuleEnabled) {
              return false;
            }
            // While the panel is on, keep every tab visible. The route guard shows Access Denied.
            const isAuthPanelFeature = Boolean(option.feature && authzPanels.includes(option.feature));
            if (isAuthPanelFeature || option.allowWhenPanelOff) {
              return true;
            }
            const permission = option.permissionActions
              ? permissionSlugs(option.feature || '', option.permissionActions, authzPanels)
              : option.permission;
            return !permission || this.authService.isAuthorizedFor(permission, option.feature);
          });
        return { ...item, options };
      })
      .filter((item: MenuItem) => item.options.length > 0);
  }

  isSelected(path: string) {
    const url = (this._route.url || '').replace(/^\//, '').split(/[?#]/)[0];
    const clean = (path || '').replace(/^\//, '');
    return url === clean || url.startsWith(clean + '/');
  }

  goto(path) {
    this._route.navigate([path]);
  }
}
